import { DirectivesModule } from 'src/app/shared/directives/directives.module';
import { SharedPipesModule } from 'src/app/shared/pipes/shared-pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BixAlertComponent } from './bix-alert.component';
import { MatIconModule } from '@angular/material/icon';
import {MatSnackBarModule} from '@angular/material/snack-bar';



@NgModule({
  declarations: [BixAlertComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatSnackBarModule,
    SharedPipesModule,
    DirectivesModule,
    TranslateModule
  ],
  exports:[BixAlertComponent]
})
export class BixAlertModule { }
